<script setup lang="ts">
const article = inject(keys.currentArticle)
</script>

<template>
  <div v-if="article?.contentType === 'article' && (article?.author || article?.photoCredit)">
    <slot />
    <span v-if="article.author">Tekst: {{ article.author }}</span>
    <span v-if="article.photoCredit">Foto: {{ article.photoCredit }}</span>
  </div>
</template>
